<template>
  <figure :class="$style.root">
    <slot />
    <figcaption v-if="$slots.caption">
      <slot name="caption" />
    </figcaption>
  </figure>
</template>

<style module>
.root {
  display: flex;
  flex-direction: column;
  margin: 0;
}
</style>
